import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionToolbar = ({ showOnDashboard = true }) => {
  const navigate = useNavigate();

  const handleCreatePost = () => {
    navigate('/idea-refiner');
  };

  if (!showOnDashboard) return null;

  return (
    <div className="quick-action-toolbar">
      <button
        className="quick-action-button primary"
        onClick={handleCreatePost}
        aria-label="Create new post"
        title="Create new post"
      >
        <Icon name="Plus" size={24} color="#FFFFFF" />
      </button>
    </div>
  );
};

export default QuickActionToolbar;